import { accountTypes } from '../../flows/shared/utils';

// MAIN TYPES
const mainTypeDisplay = {
  ROLLOVER: 'Rollover IRA',
  ROLLOVER_IRA: 'Rollover IRA',
  TRANSFER: 'Transfer IRA',
  TRANSFER_IRA: 'Transfer IRA'
};

// TRANSFER TYPES
export const transferTypeDisplay = {
  TRADITIONAL: 'Traditional IRA',
  ROTH: 'Roth IRA',
  ROTH_IRA: 'Roth IRA',
  ROLLOVER: 'Rollover IRA',
  ROLLOVER_IRA: 'Rollover IRA',
  SEP: 'SEP-IRA'
};

// CONTRIBUTORY TYPES
const contributoryTypeDisplay = {
  TRADITIONAL: 'Traditional IRA',
  TRADITIONALIRA: 'Traditional IRA',
  TRADITIONAL_IRA: 'Traditional IRA',
  ROTH: 'Roth IRA',
  ROTHIRA: 'Roth IRA',
  ROTH_IRA: 'Roth IRA'
};

// GENERAL INVESTING TYPES
export const generalInvestingTypeDisplay = {
  INDIVIDUAL: 'Individual',
  JOINT_TENANT: 'Joint Owner',
  UGMA_UTMA: 'UGMA/UTMA',
  TRUST: 'Trust',
  MINOR: 'UGMA/UTMA'
};

export const getGeneralInvestingTypeDisplay = type => {
  return generalInvestingTypeDisplay[type];
};

export const getMainTypeDisplay = type => {
  if (type === accountTypes.ROLLOVER || type === accountTypes.TRANSFER) {
    return mainTypeDisplay[type];
  }
  return getGeneralInvestingTypeDisplay(type);
};

export const getTransferTypeDisplay = type => {
  return transferTypeDisplay[type];
};

const getContributoryTypeDisplay = type => {
  return contributoryTypeDisplay[type];
};

export const getAccountTypeDisplayName = (type, subType) => {
  if (subType === 'UNKNOWN' || subType === undefined) {
    return getMainTypeDisplay(type);
  }

  switch (type) {
    case accountTypes.TRANSFER:
      return getTransferTypeDisplay(subType);
    case accountTypes.CONTRIBUTORY:
      return getContributoryTypeDisplay(subType);
    default:
      return getMainTypeDisplay(type);
  }
};
